import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const CookieConsent = () => {
  const { t } = useTranslation();

  const pluginConfig = {
    current_lang: 'en',
    autoclear_cookies: true, // default: false
    page_scripts: true, // default: false

    // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    // delay: 0,                               // default: 0
    // auto_language: null                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    onFirstAction: function(user_preferences, cookie) {
      // callback triggered only once
      // const analyticsEnabled = window.CC.allowedCategory('analytics');
      // console.log(`analytics ${analyticsEnabled ? 'enabled' : 'disabled'}`);
    },

    onAccept: function(cookie) {
      // ...
    },

    onChange: function(cookie, changed_preferences) {
      // ...
    },

    languages: {
      en: {
        consent_modal: {
          title: t('cookie_alert_title'),
          description: t('cookie_alert_description'),
          primary_btn: {
            text: t('cookie_alert_btn_accept'),
            role: 'accept_all', // 'accept_selected' or 'accept_all'
          },
          secondary_btn: {
            text: t('cookie_alert_btn_reject'),
            role: 'accept_necessary', // 'settings' or 'accept_necessary'
          },
        },
        settings_modal: {
          title: t('cookie_modal_title'),
          save_settings_btn: t('cookie_modal_settings_btn'),
          accept_all_btn: t('cookie_alert_btn_accept'),
          reject_all_btn: t('cookie_alert_btn_reject'),
          close_btn_label: t('cookie_alert_btn_close'),
          cookie_table_headers: [
            { col1: t('cookie_table_header_name') },
            { col2: t('cookie_table_header_domain') },
            { col3: t('cookie_table_header_expiration') },
            { col4: t('cookie_table_header_description') },
          ],
          blocks: [
            {
              title: t('cookie_block_1_title'),
              description: t('cookie_block_1_desc'),
            },
            {
              title: t('cookie_block_2_title'),
              description: t('cookie_block_2_desc'),
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
              },
            },
            {
              title: t('cookie_block_3_title'),
              description: t('cookie_block_3_desc'),
              toggle: {
                value: 'analytics', // your cookie category
                enabled: false,
                readonly: false,
              },
              cookie_table: [
                // list of all expected cookies
                {
                  col1: t('cookie_block_3_row_1_col1'), // '^_ga', // match all cookies starting with "_ga"
                  col2: t('cookie_block_3_row_1_col2'), // 'google.com',
                  col3: t('cookie_block_3_row_1_col3'), // '2 years',
                  col4: t('cookie_block_3_row_1_col4'), // 'description ...',
                  is_regex: true,
                },
                {
                  col1: t('cookie_block_3_row_2_col1'), // '_gid',
                  col2: t('cookie_block_3_row_2_col2'), // 'google.com',
                  col3: t('cookie_block_3_row_2_col3'), // '1 day',
                  col4: t('cookie_block_3_row_2_col4'), // 'description ...',
                },
              ],
            },
            {
              title: t('cookie_block_4_title'),
              description: t('cookie_block_4_desc'),
              toggle: {
                value: 'targeting',
                enabled: false,
                readonly: false,
              },
            },
            {
              title: t('cookie_block_5_title'),
              description: t('cookie_block_5_desc'),
            },
          ],
        },
      },
    },
  };
  useEffect(() => {
    if (!document.getElementById('cc--main')) {
      window.CC = window.initCookieConsent();
      window.CC.run(pluginConfig);
    }
  }, []);

  return null;
};
export default CookieConsent;
